/** LAYOUT
 * @param ID 對應後端 fetch layout 的 ID
 * @param NAME 對應 layout 在前端的 redux reducer 名稱與該  API 在 redux 狀態的名稱
 */
export const LAYOUT = {
  E_PRODUCT_BANNER: {
    ID: 'e_product_banner',
    NAME: 'eProductBanner'
  },
  E_PRODUCT_FEATURE: {
    ID: 'e_product_feature',
    NAME: 'eProductFeature'
  },
  E_PRODUCT_LIST: {
    ID: 'e_product_list',
    NAME: 'eProductList'
  },
  E_AGENT_PRODUCT: {
    ID: 'e_agent_product',
    NAME: 'eAgentProduct'
  }
};

/** FROM_TYPE getExperienceLayoutData API 用，紀錄從哪一頁進去 Experience page 進而打這支 API 的，目前有：1 (discover), 2 (trip list), 3 (trip previous poi detail)  6(url)，Web 目前只有 1和6 的情境，未來可能有 2 和 3
 * @see #1159
 */
export const FROM_TYPE = {
  DISCOVER: 1,
  TRIP_LIST: 2,
  TRIP_POI_DETAIL: 3,
  URL: 6
};
